import React, {useEffect, useState} from 'react'
import HeaderCard from "../../common/header-author/Header-Card";
import CardCommon from "../../cards/CardCommon";
import {get} from "sodon-http/API";
import {API_URL} from "../../../constans/API_URL";
import CustomPopup from "../../common/pop-up/CustomPopup";
import MovieModal from "../../modal/MovieModal";
import {useQuery} from "@tanstack/react-query";

export default function Ghibli() {


    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const { data: ghibli } = useQuery({
        queryKey: ['ghibli',],
        queryFn: async () => {
            return await get(`${API_URL}/api/movie/collection/15`);
        },
    });

    const hello = ghibli?.payload.slice(0,6);


    function openDialog(item) {
        setSelectedItem(item);
        setIsDialogOpen(true);
    }

    function handleClose(e) {
        setIsDialogOpen(false);
    }


    const [isDragging, setIsDragging] = useState(false);

    const handleMouseDown = () => {
        setIsDragging(false); // Reset dragging state
    };

    const handleMouseMove = () => {
        setIsDragging(true); // Pointer is moving, consider it a drag
    };

    const handleMouseUp = () => {
        if (!isDragging) {
            // If not dragging, trigger the popup
            // alert('Popup triggered!');
        }
        setIsDragging(false); // Reset dragging state after action
    };

    return (
        <div className={"container"}>
            <div className={"common"}>
                <HeaderCard title={"Жибли цуглуулга"} link={`/author-collections/15`} />
                <div className={"mt-5 grid xl:grid-cols-6 lg:grid-cols-6 gap-4 md:grid-cols-3 sm:grid-cols-3 max-sm:grid-cols-3"}>
                    {
                        hello && hello.map((item, index) => (
                             <CardCommon key={index} item={item} onClick={() => {
                                 if (!isDragging)
                                    openDialog(item.movie)
                             }} />
                        ))
                    }
                </div>
                <CustomPopup open={isDialogOpen} close={handleClose}>
                    <MovieModal
                        item={selectedItem}
                        shown={isDialogOpen}
                        setShown={value => setIsDialogOpen(value)}
                    />
                </CustomPopup>
            </div>
        </div>
    )
}
